<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import { paymentMethodText, type GenOrder, type ITrx, type ITrxCc, type ITrxTpv } from '../order'

    import { gettext as _, resolve } from 'hydria/services/gettext'

    import Date from 'hydria/components/Date.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    import 'codemirror/mode/javascript/javascript'

    import { cardData } from 'wdom/utils/credit_card'

    import CodeMirror from 'admin/components/CodeMirror.svelte'
    import TrxBeanstream from './Transactions/Beanstream.svelte'
    import TrxCheque from './Transactions/Cheque.svelte'
    import TrxInternal from './Transactions/Internal.svelte'
    import TrxStripe from './Transactions/Stripe.svelte'
    import TrxTpv from './Transactions/Tpv.svelte'
    import TrxWire from './Transactions/Wire.svelte'

    const Order = getContext('Order') as GenOrder

    const status = sderived(Order.status, ($status) => $status)
    const transactions = sderived(Order.transactions, ($transactions) => $transactions)

    let selectedTrx: ITrx | undefined = $state(undefined)
    let showRaw = $state(false)

    function guessCardType(startNums: string | undefined) {
        if (!startNums) return '?'

        const data = cardData(startNums)

        if (data && data.short) return data.short
        return '?'
    }
</script>

<div class="card">
    <div class="card-title text-primary">Transactions</div>
    <div class="card-body">
        {#if $status != 'ready' || !$transactions}
            <LoadingPattern pattern={['x', 'x']} />
        {:else if !$transactions.length}
            {$_('Il n’y a aucune transaction.')}
        {:else}
            <div class="row">
                <div class="col-sm-7 col-md-6">
                    <table class="table table-responsive table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Méthode</th>
                                <th>Succès</th>
                                <th>Extra</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each $transactions as trx}
                                <tr
                                    class="pointer"
                                    class:active={selectedTrx && selectedTrx.id == trx.id}
                                    class:warning={selectedTrx && selectedTrx.id != trx.id && (trx.payment_method != 'credit card' || !trx.success)}
                                    onclick={() => {
                                        selectedTrx = selectedTrx != null && selectedTrx.id == trx.id ? undefined : trx
                                        showRaw = false
                                    }}
                                >
                                    <td><Date value={trx.stamp} format="h-table-s" /></td>
                                    <td>{$resolve(paymentMethodText(trx.payment_method))}</td>
                                    <td class:text-danger={trx.payment_method == 'credit card' && !trx.success} class:text-warning={trx.payment_method == 'stripe' && trx.success == null}>
                                        {#if trx.payment_method == 'credit card'}
                                            {trx.success ? 'Oui' : 'Non'}
                                        {:else if trx.payment_method == 'stripe'}
                                            {trx.success ? 'Oui' : trx.success == null ? 'Ouverte' : 'Non'}
                                        {:else}
                                            –
                                        {/if}
                                    </td>
                                    <td class="extras">
                                        {#if trx.payment_method == 'credit card' && trx.data && trx.data.processor == 'tpv'}
                                            (TPV) Card={guessCardType(trx.data.tpv?.card_number_first_digits)}; Auth: {trx.data.tpv.auth_code}
                                        {:else if trx.payment_method == 'credit card' && trx.data.processor == 'beanstream'}
                                            (Global) Card={guessCardType(trx.data.query?.card_number_first_digits)}; Auth: {trx.data.response?.auth_code}
                                        {:else if trx.payment_method == 'stripe'}
                                            <!-- Card={trx.data.charge?.payment_method_details?.card?.brand}; Auth: {trx.data.charge?.payment_method_details?.card?.authorization_code} -->
                                            Card={trx.data.charge?.payment_method_details?.card?.brand}; PI: {trx.data.payment_intent_id}
                                        {:else}
                                            –
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-5 col-md-6">
                    {#if !selectedTrx}
                        Sélectionnez une transaction pour afficher les détails.
                    {:else}
                        {#if selectedTrx.payment_method == 'credit card' && selectedTrx.data && selectedTrx.data.processor == 'tpv'}
                            <TrxTpv trx={selectedTrx as ITrxTpv} />
                        {:else if selectedTrx.payment_method == 'credit card' && selectedTrx.data.processor == 'beanstream'}
                            <TrxBeanstream trx={selectedTrx as ITrxCc} />
                        {:else if selectedTrx.payment_method == 'cheque'}
                            <TrxCheque trx={selectedTrx} />
                        {:else if selectedTrx.payment_method == 'wire transfer'}
                            <TrxWire trx={selectedTrx} />
                        {:else if selectedTrx.payment_method == 'internal'}
                            <TrxInternal trx={selectedTrx} />
                        {:else if selectedTrx.payment_method == 'stripe'}
                            <TrxStripe trx={selectedTrx} />
                        {:else}
                            Mode de paiement non-supporté.
                        {/if}

                        {#if ['credit card', 'cheque', 'wire transfer', 'stripe'].includes(selectedTrx.payment_method)}
                            <hr />
                            <div class="clearfix">
                                <button type="button" class="btn btn-info btn-sm float-end" class:active={showRaw} onclick={() => (showRaw = !showRaw)}>{showRaw ? 'Cacher les données brutes' : 'Afficher les données brutes'}</button>
                            </div>
                        {/if}
                        {#if showRaw || !['stripe', 'credit card', 'cheque', 'wire transfer'].includes(selectedTrx.payment_method)}
                            <CodeMirror options={{ theme: 'ttcn', lineWrapping: true, lineNumbers: true, readOnly: false, mode: { name: 'javascript', json: true }, viewportMargin: Infinity }} value={JSON.stringify(selectedTrx, null, '\t')} />
                        {/if}
                    {/if}
                </div>
            </div>
        {/if}
    </div>
</div>
